<div class="card-button">
  <div class="mr-4">
    <i class="fas fa-user-plus"></i>
  </div>
  <div>
    <h3>Agregar beneficiario</h3>
  </div>
</div>
